import { useEffect } from "react"
import { fields, TimelineViewModel } from "../../../omnia"

export function useInitialScrollPosition(ref: React.RefObject<HTMLDivElement>, vm: TimelineViewModel) {

    useEffect(() => {

        if (!(vm && ref.current)) {
            return
        }

        const getDatePosition = d => fields.timeline.getDatePosition({
            viewConfig: vm.viewConfig,
            startDate: vm.startDate
        }, d)

        const left = getDatePosition(vm.cropYear.start)

        const right = getDatePosition(vm.cropYear.end)

        const width = ref.current.clientWidth

        const scroll = left - (width - (right - left)) / 2

        ref.current.scrollTo({ left: scroll, behavior: "smooth" })

    }, [ref.current, vm])

}
